// Filename - components/SidebarData.js

import React from "react";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";
import * as RiIcons from "react-icons/ri";
import * as SiIcons from "react-icons/si";


export const SidebarData = [
    {
        title: "Metrics",
        path:"/",
        icon: <SiIcons.SiSimpleanalytics style={{color:"black"}}/>,
        iconClosed: <RiIcons.RiArrowDownSFill style={{color:"black"}}/>,
        iconOpened: <RiIcons.RiArrowUpSFill style={{color:"black"}}/>,

        subNav: [
            {
                title: "NAS-wide Summary",
                ref:'',
                path: "/",
                requiresAuth: false,
            },
            {
                title: "Airport Summary",
                ref:'airport-summary',
                path: "/metrics/airport-summary",
                requiresAuth: false,
            },
            {
                title: "Buffer Encroachments",
                ref:'encroachments',
                path: "/metrics/encroachments",
                requiresAuth: true,
            },
            {
                title: "Air-Ground Interactions",
                ref:'air-ground-interactions',
                path: "/metrics/air-ground-interactions",
                requiresAuth: true,
            },
            {
                title: "Centerline Deviation",
                ref:'centerline-deviations',
                path: "/metrics/centerline-deviations",
                requiresAuth: true,
            },
            {
                title: "Go-Around Counts",
                ref:'go-arounds',
                path: "/metrics/go-arounds",
                requiresAuth: true,
            },
            {
                title: "Turbulence Counts",
                ref:'turbulence-counts',
                path: "/metrics/turbulence-counts",
                requiresAuth: true,
            },
            {
                title: "Flight Plan Changes",
                ref:'flight-plan-changes',
                path: "/metrics/flight-plan-changes",
                requiresAuth: true,
            },
            {
                title: "Workload Proxy Metrics",
                ref:'workload-metrics',
                path: "/metrics/workload-metrics",
                disabled:false,
                requiresAuth: true,
            },
        ],
    },
    {
        title: "Analytics",
        path: "/",
        icon: <FaIcons.FaChartLine style={{color:"black"}}/>,
        iconClosed: <RiIcons.RiArrowDownSFill style={{color:"black"}}/>,
        iconOpened: <RiIcons.RiArrowUpSFill style={{color:"black"}}/>,

        subNav: [
            {
                title: "Historic Data",
                ref:'',
                path: "/analytics/historic-data",
                cName: "sub-nav",
                requiresAuth: true,
            },
            {
                title: "Exploratory Analysis",
                ref:'',
                path: "/analytics/exploratory-analysis",
                disabled:true,
                cName: "sub-nav",
                requiresAuth: true,
            },
            {
                title: "Report Generator",
                ref:'',
                disabled:true,
                path: "/analytics/report-generator",
                requiresAuth: true,
            },
            {
                title: "Weekly Monitor",
                ref:'',
                disabled:true,
                path: "/analytics/weekly-monitor",
                requiresAuth: true,
            }
        ],
    },
    {
        title: "Airports",
        path: "/",
        icon: <IoIcons.IoMdAirplane style={{color:"black"}} />,
        subNav:[],
        requiresAuth: true,
    },
];
